import React, { useEffect, useState } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { addDoctorSpecializations, updateDoctorSpecializations } from '../../actions/userActions/doctorSpecializationAction'
import Loader from '../subComponents/Loader'
import { Redirect, useLocation, useHistory } from 'react-router-dom';
import BodyExtraSmallMedium from '../designSystem/BodyExtraSmallMedium';
import TextField from '../designSystem/TextField';
import Textarea from '../designSystem/TextArea';
import { IconButton } from '@mui/material';
import doctorspeicon from "../../assets/images/doctorspeicon.svg";
import closeModal from "../../assets/images/closeModal.svg";
import BodyLargeMedium from '../designSystem/BodyLargeMedium';
import { validateFields } from '../../utils/Validations';
import { Check, X } from 'lucide-react';
import CancelButton from '../subComponents/buttons/CustomCancelButton';
import PrimaryButton from '../subComponents/buttons/PrimaryButton';
import { t } from '../../locales/translate';
import LoadingOverlay from "../loadingOverlay/LoadingOverlay";
function AddDoctorSpecializations({ onClose, editData, onSave }) {

  const dispatch = useDispatch();
  const location = useLocation();
  const history = useHistory();
  const initialValues = { name: "", description: "" };
  const [formValues, setFormValues] = useState(initialValues);
  const [formErrors, setFormErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const handletextChange = (event) => {
    const { name, value } = event.target;
    setFormValues({
      ...formValues,
      [name]: value,
    });
  };
  useEffect(() => {
    if (editData) {
      setFormValues(editData);
    }
  }, [editData]);

  const handleSave = async (e) => {
  e.preventDefault();
  const errors = validateFields(formValues, 'doctorSpecialization');
  setFormErrors(errors);
  if (Object.keys(errors).length > 0) return;
  
  setLoading(true);
  try {
    if (editData) {
      await dispatch(updateDoctorSpecializations(formValues));
    } else {
      await dispatch(addDoctorSpecializations(formValues));
    }
    setLoading(false);
    onSave(formValues);
  } catch (error) {
    console.error("Error saving doctor specialization:", error);
    setLoading(false);
  }
};
  return (
    <>
      <div className="dynamicmodal-overlay">
     <div className="dynamicmodal-container overlay-wrapper">
  <LoadingOverlay isVisible={loading} />
  <div className={loading ? 'blur' : ''}>
    <div className="dynamicmodal-header">
      <div className="dynamicmodal-header-left">
        <div className="icon">
          <img src={doctorspeicon} alt="doctorspeicon" />
        </div>
        <div className="text">
          <h2 className="modalheading">
            {editData ? "Edit Doctor Specialization" : t("addDoctorSpecialization")}
          </h2>
          <p className="modaldescription">
            {t("addDoctorSpecializationTip")}
          </p>
        </div>
      </div>
      <div className="dynamicmodal-header-right">
        <IconButton onClick={onClose}>
          <img src={closeModal} alt="close" />
        </IconButton>
      </div>
    </div>
  </div>


          <form onSubmit={handleSave}>
            <div className="dynamicmodal-body">

              <TextField
                name="name"
                label={`${t("name")} *`}
                type='text'
                value={formValues.name}
                onChange={handletextChange}
                placeholder={t("name")}
                error={formErrors.name}
              />

              <Textarea
                name="description"
                label={`${t("description")} *`}
                placeholder={t("description")}
                value={formValues.description}
                onChange={handletextChange}
                error={formErrors.description}
              />
            </div>

            <div className="dynamicmodal-footer">
             <CancelButton
              onClick={onClose}
              text={t("cancel")}
              width={document.body.dir === "rtl" ? "119px" : ""}
              />
              <PrimaryButton
              text={t("save")}
              icon={Check}
              width={document.body.dir === "rtl" ? "123px" : ""}
              />
            </div>
          </form>
        </div>
      </div>
    </>
  )
}

export default AddDoctorSpecializations
